"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var FileTypeZip = function FileTypeZip(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    fill: "none"
  }, props), (0, _preact.h)("path", {
    fill: "#5c6970",
    fillRule: "evenodd",
    d: "M8 0C5.796875 0 4 1.796875 4 4v7H1c-.550781 0-1 .449219-1 1v6c0 .550781.449219 1 1 1h3v3c0 2.203125 1.796875 4 4 4h12c2.203125 0 4-1.796875 4-4V8c0-1.0625-.972656-2.070312-2.71875-3.78125-.242187-.238281-.503906-.503906-.75-.75-.246094-.246094-.511719-.476562-.75-.71875C18.070313 1.003906 17.0625 0 16 0H8zm0 2h7.28125c.722656.183594.71875 1.050781.71875 1.9375V7c0 .550781.449219 1 1 1h3c.996094 0 2 .003906 2 1v13c0 1.105469-.894531 2-2 2H8c-1.105469 0-2-.894531-2-2v-3h12c.550781 0 1-.449219 1-1v-6c0-.550781-.449219-1-1-1H6V4c0-1.105469.894531-2 2-2z"
  }), (0, _preact.h)("path", {
    fill: "#fff",
    d: "M5.08008 17.0586h2.86719V18H3.61523v-.6875l2.8125-4.0508H3.61914v-.9492h4.26563v.6719l-2.80469 4.0742zm4.85156.9414H8.75977v-5.6875h1.17187V18zm2.25781-2.004v2.004h-1.17188v-5.6875h2.21875c.42709 0 .80274.0781 1.12696.2344.32422.1562.57357.3782.74805.666.17448.2877.26172.6152.26172.9824 0 .5573-.19075.9967-.57227 1.3183-.38151.3216-.90951.4824-1.58398.4824h-1.02735zm0-.9492h1.04688c.30991 0 .54624-.0729.70899-.2188.16276-.1458.24414-.3541.24414-.625 0-.2786-.08203-.5039-.24609-.6758-.16407-.1718-.39063-.2604-.67969-.2656h-1.07422v1.7852z"
  }));
};

var _default = FileTypeZip;
exports.default = _default;